export default async function sendEmail(payload) {
  try {
    const res = await fetch(process.env.GATSBY_CONTACT_SENDMAIL_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      redirect: "follow",
    })

    if (res.status !== 200) {
      throw new Error("Oops status code not OK. Please refresh and retry.")
    }
    return res
  } catch (err) {
    throw err
  }
}
